import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-telephone-input/css/default.css';
import styles from './login.module.scss';

const ApplicationStatus = ({ userData }) => {
  const successMsgRef = useRef();
  return (
    <form name="loginForm" className={styles.login_form} style={{ marginTop: '4%' }}>
      <div className={styles.login_form_wrapper} style={{ width: '700px' }}>
        <div className={styles.welcome} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
        {userData?.application_success_message && userData?.application_success_message !== '<p><br></p>' ? (
          <>
            <div
              key="postSuccessMsg"
                  // eslint-disable-next-line react/no-danger, no-eval, prefer-template
              dangerouslySetInnerHTML={{ __html: eval('`' + userData?.application_success_message + '`') }}
            />
            <div style={{ display: 'none' }}>
              <div
                ref={successMsgRef}
                key="postSuccessMsg"
                    // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                dangerouslySetInnerHTML={{ __html: eval('`' + userData?.application_success_message + '`') }}
              />
            </div>
          </>
        ) : (
          <FormattedMessage id="adp.application.status1" defaultMessage="Your application has been submitted successfully." />
        )}
        </div>
      </div>
    </form>
  );
};

export default ApplicationStatus;
